import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as ENV } from './../../../environments/environment';
import * as apiUrl from '../constants/api-urls';
import { BehaviorSubject, Subject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  /**notification status */
  triggerNotificationStatus : any = new BehaviorSubject(true)
  triggerNotificationSymbol : any = new BehaviorSubject(false);


  api_url = `${ENV.API_ENDPOINT}`;
  constructor(private http: HttpClient) { }

  /** To Get Notification Status */
  getNotificationStatuService(){
    let url = this.api_url + apiUrl.dashboard.getNotificationStatus
    return this.http.get(url)
  }

  /** To get the list of notifications */
  getNotificationService() {
    let url = this.api_url + apiUrl.dashboard.getNotification;
    return this.http.get(url)
  }

  /** To read the list of notifications */
  readNotificationService(payload:any) {
    let url = this.api_url + apiUrl.dashboard.readNotification
    return this.http.post(url,payload)
  }

  /** To read all the notifications */
  readAllNotificationService(){
    let url = this.api_url + apiUrl.dashboard.allRead
    return this.http.get(url)
  }

}
